/*
 * @Description: 收款管理
 * @Author: lijinpeng
 * @Date: 2023-02-26 10:34:25
 * @LastEditTime: 2023-11-14 16:44:21
 * @LastEditors: WangYuhan
 */

// 引入api请求方法
import { captainList } from '@/api/captain';
import { getProjectListByBid } from '@/api/common';

const storeModuleName = 'captainModule';

const state = {
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'autocomplete',
      param: 'projectName',
      value: '',
      valueType: 'string',
      label: '项目名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getProjectList`,
    },
    {
      style: 'input',
      param: 'payeeName',
      value: '',
      valueType: 'string',
      label: '经纪人姓名',
      placeholder: '请输入',
      clearable: true,
    },
  ],
  // 接口调用参数
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '经纪人姓名',
        prop: 'payeeName',
        width: 60,
        checked: 1,
        sortable: true,
      },
      {
        label: '手机号',
        prop: 'reserveMobileNo',
        width: 80,
        checked: 1,
        sortable: true,
      },
      {
        label: '身份证号',
        prop: 'payeeIdentityNo',
        width: 100,
        checked: 1,
        sortable: true,
      },
      {
        label: '银行卡',
        prop: 'payeeBankCardNo',
        width: 100,
        checked: 1,
        sortable: true,
      },
      {
        label: '已收款金额(元)',
        prop: 'amount',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-amount',
      },
      {
        label: '所属项目',
        prop: '',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-project',
      },

      {
        label: '操作',
        prop: '',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-status',
      },
    ],
  },
  companyList: [], // 企业列表
  companyInfo: '', // 当前选中的企业信息
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.multiple && item.value === 'string') {
        params[item.param] = item.value.toString();
      } else {
        params[item.param] = item.value;
      }
    });
    const { data } = await captainList(Object.assign({}, params, context.state.postParams));
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data, { list: data.records }),
    });
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  // 获取项目列表
  getProjectList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getProjectListByBid({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.name;
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
};

// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        item.value = '';
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        state.parameters[1].value = '';
        state.postParams.projectId = '';
        break;
      case 'projectName':
        state.postParams.projectId = payload.id;
        break;
      default:
        break;
    }
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
